import dayjs from "dayjs";

export const dateFormat: string = "YYYY-MM-DD";

export const minDate: string = dayjs().startOf('year').format(dateFormat);
export const maxDate: string = dayjs().endOf('year').format(dateFormat);
